import { render, staticRenderFns } from "./half-year.vue?vue&type=template&id=74bb97d3&scoped=true"
import script from "./half-year.vue?vue&type=script&lang=js"
export * from "./half-year.vue?vue&type=script&lang=js"
import style0 from "./half-year.vue?vue&type=style&index=0&id=74bb97d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb97d3",
  null
  
)

export default component.exports